// web/assets/src/js/index.js

// Optional: pull in your Sass entry so Vite extracts CSS on build
import '../sass/app.scss'

// Your feature modules (unchanged)
import { init as initScrollAnimation }   from './_scrollanimations'
import { init as initSwipers }           from './_swipers'
import { init as initNav }               from './_nav'
import { init as initWizard }            from './_wizard'
import { init as initProductCustomisation } from './_productcustomisation'
import { init as initModals }            from './_modals'
import { init as initMisc }              from './_misc'
import { init as initNewsletter }        from './_newsletter'
import { init as initFindStore }         from './_findStore'
import { init as initSingleStore }       from './_singleStore'
import { init as initListEvents }        from './_listEvents'
import { init as initSingleEvent }       from './_singleEvent'
import { init as initThreeColSearch }    from './_threeColSearchField'
import { init as initSondek }            from './_sondek'

// ---- Config / env -----------------------------------------------------------

// Prefer Vite envs when present (set in .env / .env.local). Example:
// VITE_API_BASE=https://www.linn.co.uk/api/
const envApiBase = import.meta.env?.VITE_API_BASE

// Maintain your original hostname logic as a fallback:
const hostname = location.hostname
const live = hostname === 'linn.co.uk' || hostname === 'www.linn.co.uk' || hostname === 'www-sys.linn.co.uk'

const apiBase =
  envApiBase ??
  (live ? 'https://www.linn.co.uk/api/' : 'https://www-sys.linn.co.uk/api/')

// Google Maps key: prefer a data attribute (see Twig note below) but keep your global fallback
const googleApiKey =
  document.documentElement.dataset.googleMapsKey || window.mapsApiKey || ''

// ---- Boot sequence ----------------------------------------------------------

// Run ASAP, but after DOM is ready so querySelectors in modules don’t race
const onReady = (fn) =>
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', fn, { once: true })
    : fn()

onReady(() => {
  // stop CSS transitions during initial paint
  document.body.classList.remove('preload')

  // modules that can init immediately
  initSwipers()
  initNav()
  initWizard()
  initProductCustomisation()
  initModals()
  initMisc()
  initThreeColSearch()

  // delayed init for scroll animations (keeps your original 100ms pause)
  setTimeout(() => {
    initScrollAnimation()
  }, 100)

  // API-backed modules
  initNewsletter(apiBase)
  initFindStore(apiBase, googleApiKey)
  initSingleStore(apiBase, googleApiKey)
  initListEvents(apiBase, googleApiKey)
  initSingleEvent(apiBase, googleApiKey)
  initSondek(apiBase)
})

// ---- HMR hooks (optional but nice) ------------------------------------------
if (import.meta.hot) {
  import.meta.hot.accept() // accept updates to this module & deps

  // If you want to clean up side-effects (event listeners, timers) on hot replace:
  import.meta.hot.dispose(() => {
    // e.g., clearInterval(something); removeEventListener(...); etc.
  })
}
